import { render, staticRenderFns } from "./dangan.vue?vue&type=template&id=5a41be67&"
import script from "./dangan.vue?vue&type=script&lang=js&"
export * from "./dangan.vue?vue&type=script&lang=js&"
import style0 from "./dangan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports